import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/index/index.vue')
  },
  // 添加通配符路由，确保刷新页面时能正确匹配
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  // 在微前端环境中使用history模式，独立运行时使用hash模式
  history: (window as any).__POWERED_BY_QIANKUN__ 
    ? createWebHistory('/')
    : createWebHashHistory(),
  routes
})

export default router
